export const splitTreatmentIndex = [
  'autoship_cancel_to_update_payment',
  'nicotine-strength-text',
  'checkout-quick-reorder',
  'convert-order-to-subscription',
  'default-to-autoship',
  'enable-autoship-paypal',
];
